import { Injectable } from "@angular/core";
import { ModalService } from "./modal.service";

@Injectable({ providedIn: "root" })
export class FileValidationService {
    constructor(private modalService: ModalService) {
    }

    public validateFiles(selectedFiles, expectedCount = 0) {
        let isValid = true;
        if (!selectedFiles || selectedFiles.length <= 0) {
            this.modalService.showModal('If you have selected files click Upload All to continue.',
                "Please select files to continue");
            isValid = false;
        } else if (expectedCount !== 0 && expectedCount !== selectedFiles.length) {
            this.modalService.showModal(`You have to select ${expectedCount} files to continue!`,
                "Please select files to continue");
            isValid = false;
        }

        return isValid;
    }

    public getFileTypeCount(selectedFiles: string[], fileExtension: string) {
        const fileCount = selectedFiles.filter(((item) => item.slice(item.lastIndexOf('.') + 1).toLowerCase() == fileExtension)).length;
        return fileCount;
    }
}
